__turbopack_context__.v({
  "container": "ImageWithSource-module__EiqwCq__container",
});
